import React from 'react';
import './ConfirmationPopUp.scss';
import FuntoneButton from '../../Components/FuntoneButton/FuntoneButton';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';

const ConfirmationPopUp = ({title, confirmText, cancelText, onConfirmDelete, onCancel}) => {
  return (
    <div className='confirmation-pop-up'>
      <div className='pop-up-content'>
        <div className='pop-up-title'>{title}</div>
        <div className='pop-up-buttons'>
          <FuntoneButton variant='primary' text={confirmText} onClick={onConfirmDelete} />
          <BtnWhiteBlackBorderBigSize text={cancelText} onclick={onCancel} />
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopUp;
